import { WebCheckInFormFields } from "../../components/Layouts/WebCheckInForms/FormOptions";

export const PrivateUserForm = {
  country: WebCheckInFormFields.country,
  birthDate: {
    ...WebCheckInFormFields.birthDate,
    variant: "standard",
    required: true,
  },
  city: WebCheckInFormFields.city,
  birthNation: {
    ...WebCheckInFormFields.birthNation,
    type: "select",
    variant: "standard",
  },
  state: WebCheckInFormFields.state,
  birthPlace: WebCheckInFormFields.birthPlace,
  zip: WebCheckInFormFields.zip,
  birthProv: WebCheckInFormFields.birthProv,
  streetName: {
    ...WebCheckInFormFields.streetName,
    variant: "standard",
  },
  n: WebCheckInFormFields.n,
  // field1: WebCheckInFormFields.dummyNode,
  gender: { ...WebCheckInFormFields.gender, required: true },
  // field2: WebCheckInFormFields.dummyNode,
  ssn: WebCheckInFormFields.ssn,
  // flightNumber: {
  //   type: "text",
  //   label: "Flight Number",
  //   key: "flightNumber",
  //   placeholder: "Flight Number",
  //   required: false,
  //   options: [],
  // },
};
